<!-- source: https://tailwindcss.com/plus/ui-blocks/application-ui/overlays/modal-dialogs -->

<template>
    <TransitionRoot
        as="template"
        :show="open"
        class="hiorg-vue-app"
    >
        <Dialog
            class="tw:relative tw:z-10"
            @close="open = false"
        >
            <TransitionChild
                as="template"
                enter="tw:ease-out tw:duration-300"
                enter-from="tw:opacity-0"
                enter-to="tw:opacity-100"
                leave="tw:ease-in tw:duration-200"
                leave-from="tw:opacity-100"
                leave-to="tw:opacity-0"
            >
                <div class="tw:fixed tw:inset-0 tw:bg-gray-500/75 tw:transition-opacity" />
            </TransitionChild>

            <div class="tw:fixed tw:inset-0 tw:z-10 tw:w-screen tw:overflow-y-auto">
                <div class="tw:flex tw:min-h-full tw:items-end tw:justify-center tw:p-4 tw:text-center tw:sm:items-center tw:sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="tw:ease-out tw:duration-300"
                        enter-from="tw:opacity-0 tw:translate-y-4 tw:sm:translate-y-0 tw:sm:scale-95"
                        enter-to="tw:opacity-100 tw:translate-y-0 tw:sm:scale-100"
                        leave="tw:ease-in tw:duration-200"
                        leave-from="tw:opacity-100 tw:translate-y-0 tw:sm:scale-100"
                        leave-to="tw:opacity-0 tw:translate-y-4 tw:sm:translate-y-0 tw:sm:scale-95"
                    >
                        <DialogPanel class="tw:relative tw:transform tw:overflow-hidden tw:rounded-lg tw:bg-white tw:px-4 tw:pt-5 tw:pb-4 tw:text-left tw:shadow-xl tw:transition-all tw:sm:my-8 tw:sm:w-full tw:sm:max-w-sm tw:sm:p-6">
                            <div>
                                <div class="tw:text-center">
                                    <DialogTitle
                                        as="h3"
                                        class="tw:text-base tw:font-semibold tw:text-gray-900"
                                    >
                                        <span v-html="titel" />
                                    </DialogTitle>
                                    <div class="tw:mt-2">
                                        <p
                                            class="tw:text-sm tw:text-gray-500"
                                            v-html="content"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="tw:mt-5 tw:sm:mt-6">
                                <button
                                    type="button"
                                    class="tw:inline-flex tw:w-full tw:justify-center tw:rounded-md tw:bg-hiorg-hellrot-600 tw:px-3 tw:py-2 tw:text-sm tw:font-semibold tw:text-white tw:shadow-xs tw:hover:bg-hiorg-hellrot-500 tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-hiorg-hellrot-600"
                                    @click="open = false"
                                >
                                    {{ buttonText }}
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {computed} from "vue";

const props = defineProps<{
    modelValue: boolean;
    titel: string;
    content: string;
    buttonText: string;
}>();
const emit = defineEmits<{
    (event: "update:modelValue", value: boolean): void;
}>();

const open = computed({
    get() {
        return props.modelValue;
    },
    set(value: boolean) {
        emit("update:modelValue", value);
    },
});
</script>
